import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/w3eraacademy_nextjsapp/src/components/CoursesInnerPage.tsx");
